import { ClientConfig } from 'client/configuration';

/**
 * @returns {string} same as the value of `x-az` response header - e.g. "us-west-2c"
 */
export function getAvailabilityZone() {
  return ClientConfig.get('awsAvailabilityZone', '');
}
